import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useField } from "react-final-form";
import { AutocompleteInput } from "@vk-hr-tek/ui/input";
import { compose } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function AutocompleteInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else AutocompleteInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const AutocompleteInput_AutocompleteInput = (t0)=>{
    const $ = c(53);
    let additionalFilters;
    let label;
    let labelIcon;
    let loadItems;
    let minInputValueLength;
    let name;
    let onChange;
    let placeholder;
    let renderOption;
    let rest;
    let search;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let tooltip;
    let validate;
    if ($[0] !== t0) {
        ({ label, labelIcon, search, name, onChange, placeholder, required: t1, clearable: t2, disabled: t3, loading: t4, limit: t5, loadItems, renderOption, tooltip, showError: t6, additionalFilters, minInputValueLength, testId, withoutMargin: t7, validate, validationWithoutTouch: t8, validationWhenDisabled: t9 } = t0), rest = _object_without_properties(t0, [
            "label",
            "labelIcon",
            "search",
            "name",
            "onChange",
            "placeholder",
            "required",
            "clearable",
            "disabled",
            "loading",
            "limit",
            "loadItems",
            "renderOption",
            "tooltip",
            "showError",
            "additionalFilters",
            "minInputValueLength",
            "testId",
            "withoutMargin",
            "validate",
            "validationWithoutTouch",
            "validationWhenDisabled"
        ]);
        $[0] = t0;
        $[1] = additionalFilters;
        $[2] = label;
        $[3] = labelIcon;
        $[4] = loadItems;
        $[5] = minInputValueLength;
        $[6] = name;
        $[7] = onChange;
        $[8] = placeholder;
        $[9] = renderOption;
        $[10] = rest;
        $[11] = search;
        $[12] = t1;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
        $[21] = testId;
        $[22] = tooltip;
        $[23] = validate;
    } else {
        additionalFilters = $[1];
        label = $[2];
        labelIcon = $[3];
        loadItems = $[4];
        minInputValueLength = $[5];
        name = $[6];
        onChange = $[7];
        placeholder = $[8];
        renderOption = $[9];
        rest = $[10];
        search = $[11];
        t1 = $[12];
        t2 = $[13];
        t3 = $[14];
        t4 = $[15];
        t5 = $[16];
        t6 = $[17];
        t7 = $[18];
        t8 = $[19];
        t9 = $[20];
        testId = $[21];
        tooltip = $[22];
        validate = $[23];
    }
    const required = void 0 === t1 ? false : t1;
    const clearable = void 0 === t2 ? false : t2;
    const disabled = void 0 === t3 ? false : t3;
    const loading = void 0 === t4 ? false : t4;
    const limit = void 0 === t5 ? 50 : t5;
    const showError = void 0 === t6 ? true : t6;
    const withoutMargin = void 0 === t7 ? false : t7;
    const validationWithoutTouch = void 0 === t8 ? false : t8;
    const validationWhenDisabled = void 0 === t9 ? false : t9;
    let t10;
    if ($[24] !== validate) {
        t10 = Array.isArray(validate) ? compose(validate) : validate;
        $[24] = validate;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== rest || $[27] !== t10) {
        t11 = _object_spread_props(_object_spread({}, rest), {
            validate: t10
        });
        $[26] = rest;
        $[27] = t10;
        $[28] = t11;
    } else t11 = $[28];
    const { input, meta } = useField(name, t11);
    const handleChange = _temp;
    const errorDisabled = disabled || !validationWhenDisabled;
    const renderError = !errorDisabled && validationWithoutTouch ? !!input.value && !!meta.error : meta.touched && !!meta.error;
    let t12;
    if ($[29] !== input || $[30] !== onChange) {
        t12 = handleChange(input, onChange);
        $[29] = input;
        $[30] = onChange;
        $[31] = t12;
    } else t12 = $[31];
    const t13 = renderError && showError && meta.error;
    let t14;
    if ($[32] !== additionalFilters || $[33] !== clearable || $[34] !== disabled || $[35] !== input || $[36] !== label || $[37] !== labelIcon || $[38] !== limit || $[39] !== loadItems || $[40] !== loading || $[41] !== minInputValueLength || $[42] !== placeholder || $[43] !== renderError || $[44] !== renderOption || $[45] !== required || $[46] !== search || $[47] !== t12 || $[48] !== t13 || $[49] !== testId || $[50] !== tooltip || $[51] !== withoutMargin) {
        t14 = /*#__PURE__*/ jsx(AutocompleteInput, _object_spread_props(_object_spread({}, input), {
            search: search,
            testId: testId,
            label: label,
            labelIcon: labelIcon,
            onChange: t12,
            placeholder: placeholder,
            required: required,
            clearable: clearable,
            disabled: disabled,
            loading: loading,
            limit: limit,
            loadItems: loadItems,
            renderOption: renderOption,
            error: renderError,
            helperText: t13,
            tooltip: tooltip,
            additionalFilters: additionalFilters,
            minInputValueLength: minInputValueLength,
            withoutMargin: withoutMargin
        }));
        $[32] = additionalFilters;
        $[33] = clearable;
        $[34] = disabled;
        $[35] = input;
        $[36] = label;
        $[37] = labelIcon;
        $[38] = limit;
        $[39] = loadItems;
        $[40] = loading;
        $[41] = minInputValueLength;
        $[42] = placeholder;
        $[43] = renderError;
        $[44] = renderOption;
        $[45] = required;
        $[46] = search;
        $[47] = t12;
        $[48] = t13;
        $[49] = testId;
        $[50] = tooltip;
        $[51] = withoutMargin;
        $[52] = t14;
    } else t14 = $[52];
    return t14;
};
function _temp(inputInner, userOnChange) {
    return (value, option)=>{
        inputInner.onChange(value);
        null == userOnChange || userOnChange(value, option);
    };
}
export { AutocompleteInput_AutocompleteInput as AutocompleteInput };
